import sendErrorReport from 'common/utils/sendErrorReport';
import { IntercomAPI } from 'modules/intercom';

import { SupportLayerProviderProps } from './types';

export const handleDisplayChat: SupportLayerProviderProps['onDisplayChat'] = (initialMessage, metadata) => {
  if (initialMessage || metadata) {
    IntercomAPI.showNewMessage(initialMessage);
    return;
  }

  IntercomAPI.showMessages();
};

export const handleError: SupportLayerProviderProps['onError'] = error => {
  sendErrorReport(error, 'Support Layer Web SDK');
};
